// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Error-module__error___uKXaf{padding:4px 0 0 0;color:#e03a3e}`, "",{"version":3,"sources":["webpack://./assets/js/src/components/forms/Error/Error.module.scss"],"names":[],"mappings":"AAAA,6BACI,iBAAA,CACA,aAAA","sourcesContent":[".error {\n    padding: 4px 0 0 0;\n    color: #e03a3e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `Error-module__error___uKXaf`
};
export default ___CSS_LOADER_EXPORT___;
